import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { NewNoteProvider } from '../components/NewNoteDialog';
import { QuickSwitcher } from '../components/QuickSwitcher';
import { Sidebar } from '../components/Sidebar';
import { useCampaign, useCampaignId } from '../hooks';
import { useOfflineSync } from '../offline';
import { useCampaignEvents } from '../realtime';

export function CampaignLayout() {
  const cid = useCampaignId();
  const campaign = useCampaign(cid);
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  // Spieler bekommen nur „etwas hat sich geändert“ (ohne IDs) und ziehen die gefilterten Daten nach
  useCampaignEvents(campaign.data ? cid : '', campaign.data?.role === 'player');
  // Lokale Kopie für Unterbrechungen (WLAN, VPN) aktuell halten
  useOfflineSync(cid);

  useEffect(() => setMenuOpen(false), [location.pathname]);
  useEffect(() => {
    if (campaign.data) document.title = `${campaign.data.name} · Kartothek`;
  }, [campaign.data]);

  return (
    <NewNoteProvider>
      <div className={`layout ${menuOpen ? 'menu-open' : ''}`}>
        <button className="menu-toggle" onClick={() => setMenuOpen((o) => !o)} aria-label="Menü">
          ☰
        </button>
        <Sidebar onNavigate={() => setMenuOpen(false)} />
        <main className="main">
          <Outlet />
        </main>
      </div>
      <QuickSwitcher cid={cid} />
    </NewNoteProvider>
  );
}
